<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('expensePosting.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('expensePosting.pageTitle'),
            href: '/admin/expense-postings'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-p-2 ts-rounded-md">
          <div
            class="ts-w-full ts-h-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-3 ts-relative"
          >
            <BasicInfo v-model="model" :validate="errors" ref="basicInfo" />
          </div>
        </div>
        <div class="ts-p-2 ts-rounded-md">
          <div
            class="ts-w-full ts-h-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-3 ts-relative"
          >
            <Detail v-model="model" :validate="errors" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-card-wrapper>
        <div class="row">
          <div
            class="col-md-12 ts-flex ts-items-center ts-justify-end ts-space-x-3"
          >
            <ts-button
              :disabled="loading"
              @click.prevent="$router.push({ name: 'expense-posting' })"
              >{{ $t('cancel') }}
            </ts-button>
            <ts-button
              :disabled="loading"
              @click.prevent="onSaveAddNew"
              outline
              color="primary"
              >{{ $t('saveAddNew') }}
            </ts-button>
            <ts-button
              :disabled="loading"
              @click.prevent="onSave"
              color="primary"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import BasicInfo from './components/basic-info.vue'
import Detail from './components/detail.vue'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'create',
  components: {
    BasicInfo,
    Detail
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      model: {
        exp_date: moment().format('DD-MM-YYYY'),
        expense_type: 0,
        currency_id: null,
        fx_rate: null,
        fx_rate_ratio: null,
        grand_total: null,
        advance_id: null,
        advance_status: null,
        reimburse_by: null,
        remarks: null,
        payment_method_id: 1,
        bank_name: null,
        account_name: null,
        account_number: null,
        details: [],
        document_attacheds: []
      }
    }
  },
  methods: {
    ...mapActions('expense/expensePosting', ['getFormViewModel', 'store']),
    async getPreData({ params, index }) {
      this.loading = true
      await this.getFormViewModel({ index: index, params: params })
        .then(response => {
          let default_currency = response.data.currency.find(
            el => el.is_default == true
          )
          this.model.currency_id = default_currency
            ? default_currency.currency_id
            : null
          this.model.fx_rate = 1
          this.model.fx_rate_ratio = 1
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => (this.loading = false))
    },
    async onSave() {
      this.loading = true
      await this.$refs.basicInfo.onUploadDocumentAttached()
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'expense-posting' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSaveAddNew() {
      this.loading = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput() {
      this.model.exp_date = moment().format('DD-MM-YYYY')
      this.model.expense_type = 0
      this.model.currency_id = null
      this.model.fx_rate = null
      this.model.fx_rate_ratio = null
      this.model.grand_total = null
      this.model.advance_id = null
      this.model.advance_status = null
      this.model.reimburse_by = null
      this.model.remarks = null
      this.model.payment_method_id = 1
      this.model.bank_name = null
      this.model.account_name = null
      this.model.account_number = null
      this.model.details = []
      this.model.document_attacheds = []
    }
  },
  watch: {},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPreData({
        params: {},
        index: undefined
      })
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('expense/expensePosting/SET_EDIT_DATA', {})
    next()
  }
}
</script>
<style scoped>
/* * {
  font-family: Roboto, Khmer, 'Font Awesome 5 Free';
} */
</style>
